import { defineCustomElement } from '@tyler-components-web/core';
import { RadioComponent } from './radio';
export * from './radio-constants';
export * from './radio';
export function defineRadioComponent() {
    defineCustomElement(RadioComponent);
}
